
const langText = require('./language');
/**
 * 中英文切换
 * @param {*} currentLang key
 * @param {*} module 模块
 * @param {*} html 是否自动换行
 * @param {*} capitalize 每个单词首字母大写,以空格切割
 * @param {*} cb 回调
 * @returns
 */
export function TLang(currentLang, module = '', html = false, capitalize = false, cb) {
  // console.log(currentLang,"我要被转换成英文了 大宝贝");


  // 不能缺少模块名
  if (!module) {
    console.error('TLang - e  rror: 请指定业务模块');
    return currentLang;
  }
  /** 输入中文，根据Cookie: df_lang=zh-CN中文，默认中文; df_lang=en-US英文; */
  let dfLang = getCookie('df_lang') || '';
  // 兼容历史逻辑
  const _window: any = window;
  const { union_isBilingual } = _window;
  // 未读取到多语言源文件或无语言设置直接返回默认值
  if (!langText) {
    return currentLang;
  }
  if (union_isBilingual) {
    dfLang = 'en';
  } else if (dfLang) {
    switch (dfLang) {
    case 'zh-CN':
      dfLang = 'cn';
      break;
    case 'en-US':
      dfLang = 'en';
      break;
    default:
      break;
    }
  } else {
    dfLang = 'cn';
  }

  const data = langText.data[module]&&langText.data[module][dfLang];

  if (data) {
    let EN_WORD = data[currentLang] || '';
    if (capitalize) {
      EN_WORD = convertFirstLetter(data[currentLang]);
    }
    if (html) {
      EN_WORD = `<div style="white-space: normal;width: 100%;">${EN_WORD}</div>`;
    }
    if (cb instanceof Function) {
      return cb(EN_WORD);
    }
    return EN_WORD || currentLang;
  }
  return currentLang;
}
export function getCookie(cookieName) {
  var cookieString = document.cookie;
  var start = cookieString.indexOf(cookieName + '=');
  // 加上等号的原因是避免在某些 Cookie 的值里有
  // 与 cookieName 一样的字符串。
  if (start == -1) // 找不到
    return null;
  start += cookieName.length + 1;
  var end = cookieString.indexOf(';', start);
  if (end == -1) return unescape(cookieString.substring(start));
  return unescape(cookieString.substring(start, end));
}
/**
 * 替换文案
 * @param {*} key 关键字
 * @param {*} value 替换值
 * @param {*} str 原始文案
 * @param {*} isAll 是否全部替换
 */
export function ReplaceText(key, value, str, isAll?) {
  if (key && value !== undefined && value !== null && str) {
    if (!isAll) {
      return str.replace(key, value);
    } else {
      return str.replace(new RegExp(key, 'gm'), value);
    }
  } else {
    return str;
  }
}
/**
 * 首字母转换大写
 * @param {*} str 以空格转换
 */
function convertFirstLetter(str = '') {
  const strList = str.split(' ');
  const newList = strList.map((t) => t = t ? t.replace(/^\S/, (s) => s.toUpperCase()) : t);
  return newList.join(' ');
}


/**
 * 判断是否是中文
 */
 export function CheckCN() {
  /** 输入中文，根据Cookie: df_lang=zh-CN中文，默认中文; df_lang=en-US英文; */
  let dfLang = getCookie('df_lang') || '';
  // 兼容历史逻辑
  const { union_isBilingual } = window;
  if (union_isBilingual) {
      dfLang = 'en';
  } else if (dfLang) {
      switch (dfLang) {
          case 'zh-CN':
              dfLang = 'cn';
              break;
          case 'en-US':
              dfLang = 'en';
              break;
          default:
              break;
      }

  } else {
      dfLang = 'cn';
  }
  return dfLang === 'cn';
}

// 这里抛出这个方法 将方法注入window中
export default function injectionWindow() {
  const _window: any = window;
  _window.TLang = TLang;
  _window.ReplaceText = ReplaceText;
  _window.union_name = _window.TLang('福豆', 'card');
}










